import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { thomasvilleConfig } from "./data";

export default function ThomasvillePage() {
  return <CityPageTemplate config={thomasvilleConfig} />;
}